import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toggleLike } from "../likes/likesActions";
import { addToWishlist, removeFromWishlist } from "../wishlist/wishlistActions";
import DateTimePicker from "../watchlist/DateTimePicker";

const MovieCard = ({ movie }) => {
  const [showPicker, setShowPicker] = useState(false);
  const dispatch = useDispatch();

  const isLiked = useSelector((s) => !!s.likes.items[movie.imdbID]);
  const isWishlisted = useSelector((s) => !!s.wishlist.items[movie.imdbID]);
  const watchItem = useSelector((s) => s.watchlist.items[movie.imdbID]);

  const poster =
    movie.Poster && movie.Poster !== "N/A"
      ? movie.Poster
      : "https://via.placeholder.com/300x450?text=No+Poster";

  const handleLike = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(toggleLike(movie));
  };

  const handleWishlist = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isWishlisted) {
      dispatch(removeFromWishlist(movie.imdbID));
    } else {
      dispatch(addToWishlist(movie));
    }
  };

  const handleWatchlist = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPicker(true);
  };

  return (
    <>
      <div className="movie-card">
        <img src={poster} alt={movie.Title} className="movie-card-poster" />
        <div className="movie-card-info">
          <h6 className="movie-card-title">{movie.Title}</h6>
          <span className="movie-card-year">{movie.Year}</span>
        </div>
        <div className="movie-card-overlay">
          <Link
            to={`/movie/${movie.imdbID}/cast`}
            className="overlay-btn btn-cast"
            onClick={(e) => e.stopPropagation()}
          >
            <i className="fas fa-users"></i> Cast
          </Link>
          <Link
            to={`/movie/${movie.imdbID}`}
            className="overlay-btn btn-detail"
            onClick={(e) => e.stopPropagation()}
          >
            <i className="fas fa-info-circle"></i> Details
          </Link>
          <div className="overlay-actions">
            <button
              className={`action-btn ${isLiked ? "active-like" : ""}`}
              onClick={handleLike}
              title="Like"
            >
              <i className={`${isLiked ? "fas" : "far"} fa-heart`}></i>
            </button>
            <button
              className={`action-btn ${isWishlisted ? "active-wish" : ""}`}
              onClick={handleWishlist}
              title="Wishlist"
            >
              <i className={`${isWishlisted ? "fas" : "far"} fa-bookmark`}></i>
            </button>
            <button
              className={`action-btn ${watchItem ? "active-watch" : ""}`}
              onClick={handleWatchlist}
              title="Watch List"
            >
              <i className="fas fa-calendar-plus"></i>
            </button>
          </div>
        </div>
        {watchItem && (
          <div className={`movie-card-badge badge-${watchItem.status}`}>
            {watchItem.status === "watched"
              ? "Watched"
              : watchItem.status === "shifted"
              ? "Rescheduled"
              : watchItem.scheduledDate}
          </div>
        )}
      </div>

      {showPicker && (
        <DateTimePicker movie={movie} onClose={() => setShowPicker(false)} />
      )}
    </>
  );
};

export default MovieCard;
